module.exports = __webpack_public_path__ + "static/media/239-montenegro.28b20bd9.svg";